import {
  GET_MEMBER_INFO,
  SET_MEMBER_INFO,
  SET_MEMBER_TOKEN,
  SET_MEMBER_PROFILE,
  SET_MEMBER_PHOTO,
  UPDATE_MEMBER_INFO,
} from "./actionTypes";


export const getMemberInfo = (token, history) => {
  return {
      type: GET_MEMBER_INFO,
      payload: { token, history }
  }
}

export const setMemberInfo = (memberInfo) => {
  return {
    type: SET_MEMBER_INFO,
    payload: memberInfo,
  };
};


export const setMemberToken = (token) => {
  return {
    type: SET_MEMBER_TOKEN,
    payload: token
  }
}

export const setMemberProfile = (memberProfile) => {
  return {
    type: SET_MEMBER_PROFILE,
    payload: memberProfile,
  };
};

export const setMemberPhoto = (memberPhoto) => {
  return {
    type: SET_MEMBER_PHOTO,
    payload: memberPhoto,
  };
};

export const updateMemberInfo = (memberInfo) => {
  return {
    type: UPDATE_MEMBER_INFO,
    payload: memberInfo,
  };
};


